module.exports = __webpack_public_path__ + "img/Jump Casting20.6920228f.jpg";